import { render, staticRenderFns } from "./statisticalAnalysis.vue?vue&type=template&id=0ff02211&scoped=true&"
import script from "./statisticalAnalysis.vue?vue&type=script&lang=js&"
export * from "./statisticalAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./statisticalAnalysis.vue?vue&type=style&index=0&id=0ff02211&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff02211",
  null
  
)

export default component.exports